import { clsx } from "clsx";
import React, { ButtonHTMLAttributes } from "react";
import Loader from "@/components/ui/Loader";

interface ButtonType extends ButtonHTMLAttributes<never> {
  children: React.ReactNode;
  className?: string;
  size?: string;
  theme?: string;
  inverse?: boolean;
  loading?: boolean;
}

export default function Button({
  children,
  className,
  size = "medium",
  theme = "default",
  inverse = false,
  loading,
  onClick,
  type = "button",
  disabled,
  ...props
}: ButtonType): React.ReactElement {
  let classes = clsx(
    "font-semibold w-full lg:w-72 border-2 rounded-lg px-5 flex items-center justify-center whitespace-nowrap transition",
    className,
  );

  if (size === "small") {
    classes = clsx("text-[14px]/[24px] lg:text-[16px]/[24px] h-12", classes);
  } else {
    classes = clsx("text-[16px]/[24px] lg:text-[18px]/[24px] h-14", classes);
  }

  if (theme === "black") {
    if (inverse) {
      classes = clsx(
        "border-[#151922]",
        "hover:bg-[#151922] hover:text-white",
        classes,
      );
    } else {
      classes = clsx(
        "border-transparent bg-[#151922] text-white",
        "hover:bg-[#34EEFF] hover:text-[#151922]",
        classes,
      );
    }
  } else if (theme === "red") {
    classes = clsx("border-transparent bg-[#FF0032] text-white", classes);
  } else if (theme === "gray") {
    if (inverse) {
      classes = clsx("border-[#DDDDE9]", classes);
    } else {
      classes = clsx("border-transparent bg-[#DDDDE9]", classes);
    }
  } else if (theme === "transparent") {
    classes = clsx("border-transparent", classes);
  } else {
    if (inverse) {
      classes = clsx("border-[#34EEFF]", classes);
    } else {
      classes = clsx(
        "border-transparent bg-[#34EEFF] text-[#151922]",
        "hover:bg-[#151922] hover:text-white",
        classes,
      );
    }
  }

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <Loader /> : children}
    </button>
  );
}
